import React from "react";
import {
  Route,
  Redirect,
  useHistory,
} from "react-router-dom";
import { DataContext } from "../../App";

export default function PrivateRoute({ children, origin, ...rest }) {
    const { context } = React.useContext(DataContext);
    const [requiredProp,]= React.useState(origin === "comparative" ? context.policy_selected : context.policy_detail);
    const history = useHistory();
    const [path,] = React.useState(history.location.pathname)
   
    return (
      <Route
        {...rest}
        render={({ location }) =>
        typeof requiredProp !== 'undefined' ? (
            children
            ) : (
            <Redirect 
                to = {path.slice(0,path.lastIndexOf("/"))+context.urlSearch}
            />
          )
        }
      />
    );
  }